module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "slider-color": "grey"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Details")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "2% !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Package Name",
      "rules": _vm.nameRules,
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.objPackageEdit.package.name),
      callback: function($$v) {
        _vm.$set(_vm.objPackageEdit.package, "name", $$v)
      },
      expression: "objPackageEdit.package.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Short Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Package Short Name",
      "rules": _vm.snameRules,
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.objPackageEdit.package.short_name),
      callback: function($$v) {
        _vm.$set(_vm.objPackageEdit.package, "short_name", $$v)
      },
      expression: "objPackageEdit.package.short_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Package Description",
      "rules": _vm.descriptionRules,
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.objPackageEdit.package.description),
      callback: function($$v) {
        _vm.$set(_vm.objPackageEdit.package, "description", $$v)
      },
      expression: "objPackageEdit.package.description"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "2% !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddPackageProduct()
      }
    }
  }, [_vm._v("Add Product")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.objPackageEditProducts,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "65%"
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.objPackageEdit.products,
            "label": "Type",
            "autocomplete": "",
            "solo": "",
            "item-value": "id"
          },
          model: {
            value: (props.item.product_code),
            callback: function($$v) {
              _vm.$set(props.item, "product_code", $$v)
            },
            expression: "props.item.product_code"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "25%"
          }
        }, [_c('v-text-field', {
          attrs: {
            "rules": _vm.nameRules,
            "solo": "",
            "single-line": "",
            "required": ""
          },
          model: {
            value: (props.item.capacity),
            callback: function($$v) {
              _vm.$set(props.item, "capacity", $$v)
            },
            expression: "props.item.capacity"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeletePackageProduct(props.item.product_code)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete_forever")])])])]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runAdd) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isAddValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncEditPackage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}